import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

const ShuttleActionMenu = ({ items = [] }) => (
  <Menu as="div" className="relative inline-block text-left">
    <Menu.Button
      type="button"
      className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-600 hover:bg-gray-50"
      aria-label="More actions"
    >
      <FontAwesomeIcon icon={faEllipsisVertical} />
    </Menu.Button>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items className="absolute right-0 z-40 mt-1 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/10 focus:outline-none">
        {items.map((item) => (
          <Menu.Item key={item.label}>
            {({ active }) => (
              <button
                type="button"
                className={`flex w-full px-3 py-2 text-left text-sm ${
                  active ? "bg-gray-100" : ""
                } ${item.danger ? "text-red-700" : "text-gray-700"}`}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Transition>
  </Menu>
);

export default ShuttleActionMenu;
